import React, { useRef, useState } from "react";

import { Grid } from "@material-ui/core";
import LogoCv from "../assets/logoCv.png";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  ptBR,
} from "@mui/x-data-grid";
import { ReactComponent as HelpSvg } from "../../core/assets/empty.svg";

import { Accessible, Circle, School } from "@material-ui/icons";
import calcExp from "../../core/utils/calcExp";
import formatDate from "../../core/utils/formatDate";
import renderSalary from "../../core/utils/renderSalary";
import { getCanHistory, getCandidateById } from "../hooks/useCandidate";
import { TagsJobs } from "./TagsJobs";
import getContractType from "../../core/utils/getContractType";
import getTimeType from "../../core/utils/getTimeType";
import ReactMarkdown from "react-markdown";
import { useFunctions } from "../../core/contexts/FunctionsProvider";
import compareInstrucaoCan from "../../core/utils/compareInstrucaoCan";
import {
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { RenderCliente } from "../../core/utils/renderStatus";
import useTheme from "@material-ui/core/styles/useTheme";
import SvgContainer from "../../core/components/SvgContainer";
import { useReactToPrint } from "react-to-print";
import CanInfo from "./CanInfo";

function renderChamado(
  contato_ok: number,
  chamado: number,
  chamadotexto: string,
  contato_recado: number,
  contato_recadotexto: string,
  contato_natende: number,
  contato_email: number,
  contato_whats: number,
  contato_sms: number,
  contato_stelefone: number,
  contato_trabalhando: number,
  contato_semperfil: number,
  contato_msemperfil: string,
  contato_sinteresse: number,
  contato_msinteresse: string,
  contato_preentre: number,
  veio_direto: number,
) {
  const renderStatus = (label: any, texto?: any) => {
    return (
      <div
        style={{
          marginTop: 5,
          marginBottom: 5,
        }}
      >
        <b>{label}</b>
        <br />
        {texto && (
          <span
            style={{
              display: "block",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {texto}
          </span>
        )}
      </div>
    );
  };

  const statusList: JSX.Element[] = [];

  // PRIMEIRO: Status principais (Contactado, Pré-entrevista, Veio Direto)
  if (chamado == 1) {
    statusList.push(renderStatus("Contactado"));
  }
  if (contato_preentre == 1) {
    statusList.push(renderStatus("Pré-entrevista"));
  }
  if (veio_direto == 1) {
    statusList.push(renderStatus("Veio Direto"));
  }

  // SEGUNDO: Meios de contato (Chamado, SMS, E-mail, WhatsApp)
  if (contato_ok == 1) {
    statusList.push(renderStatus("Chamado", chamadotexto));
  }
  if (contato_sms == 1) {
    statusList.push(renderStatus("SMS"));
  }
  if (contato_email == 1) {
    statusList.push(renderStatus("E-mail"));
  }
  if (contato_whats == 1) {
    statusList.push(renderStatus("WhatsApp"));
  }

  // TERCEIRO: Demais opções (Sem Interesse, Sem Telefone, Recado, etc.)
  if (contato_sinteresse == 1) {
    statusList.push(renderStatus("Sem Interesse", contato_msinteresse));
  }
  if (contato_stelefone == 1) {
    statusList.push(renderStatus("Sem Telefone"));
  }
  if (contato_recado == 1) {
    statusList.push(renderStatus("Recado", contato_recadotexto));
  }
  if (contato_trabalhando == 1) {
    statusList.push(renderStatus("Trabalhando"));
  }
  if (contato_natende == 1) {
    statusList.push(renderStatus("Não Atende"));
  }
  if (contato_semperfil == 1) {
    statusList.push(renderStatus("Sem Perfil", contato_msemperfil));
  }

  return statusList.length > 0 ? (
    <div>
      {statusList.map((status, index) => (
        <div key={index}>{status}</div>
      ))}
    </div>
  ) : null;
}

function renderEntrevista(
  entrevista_pessoal: number,
  entrevista_telefone: number,
  entrevista_video: number,
  aprovado: number,
  enviado: number,
  contato_standby: number,
  entrevista_semperfil: number,
  entrevista_msemperfil: string,
  contratadodireto: number,
  entrevista_sinteresse: number,
  entrevista_msinteresse: string,
  entrevista_disistiu: number,
  entrevista_mdisistiu: string,
) {
  const renderStatus = (label: any, texto?: any) => {
    return (
      <div
        style={{
          marginTop: 5,
          marginBottom: 5,
        }}
      >
        <b>{label}</b>
        <br />
        {texto && (
          <span
            style={{
              display: "block",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {texto}
          </span>
        )}
      </div>
    );
  };

  let status = null;

  if (
    entrevista_pessoal == 1 ||
    entrevista_telefone == 1 ||
    entrevista_video == 1
  ) {
    status = renderStatus("Entrevistado");

    if (aprovado == 1) {
      status = renderStatus("Aprovado");
    }

    if (enviado == 1) {
      status = renderStatus("Enviado");
    }

    if (contato_standby == 1) {
      status = renderStatus("Contato em StandBy");
    }

    if (entrevista_semperfil == 1) {
      status = renderStatus("Sem Perfil", entrevista_msemperfil);
    }

    if (contratadodireto == 1) {
      status = renderStatus("Contratado Direto");
    }

    if (entrevista_sinteresse == 1) {
      status = renderStatus("Sem Interesse", entrevista_msinteresse);
    }

    if (entrevista_disistiu == 1) {
      status = renderStatus("Candidato Desistiu", entrevista_mdisistiu);
    }
  } else {
    status = renderStatus("");
  }

  return status;
}

interface CurriculumProps {
  canId: number;
  data?: any;
  observ?: boolean;
  noProfile?: any[];
  selectedsCan?: any[];
  isLoadingCV?: boolean;
  type?: string;
  setRef: (ref: React.MutableRefObject<null>) => void;
  printTrigger?: number;
  onPrintReady?: () => void;
}

export type DatCvType = {
  pessoal_codigo: number;
  pessoal_cpf: string;
  pessoal_nome: string;
  pessoal_email: string;
  pessoal_endereco: string;
  pessoal_bairro: string;
  pessoal_cidade: string;
  pessoal_uf: string;
  pessoal_cep: string;
  pessoal_complemento: any;
  pessoal_dtnasc: string;
  idade: number;
  pessoal_sexo: string;
  pessoal_codestcivil: string;
  pessoal_codinstrucao: string;
  instrucao_descricao: string;
  pessoal_rg: any;
  pessoal_rgemissor: any;
  pessoal_rgdtemissao: string;
  pessoal_pis: any;
  pessoal_ctps: any;
  pessoal_ctpsserie: any;
  pessoal_ctpsuf: any;
  pessoal_teleitor: any;
  pessoal_teleitorzona: any;
  pessoal_teleitorsecao: any;
  pessoal_cnh: number;
  pessoal_nocnh: any;
  pessoal_tpcnh: string;
  pessoal_dtinclusao: string;
  pessoal_dtalteracao: string;
  pessoal_filhos: number;
  pessoal_pveiculo: any;
  pessoal_nfoto: any;
  pessoal_formacao: any;
  pessoal_cursando: number;
  pessoal_turno: string;
  pessoal_ingles: any;
  pessoal_espanhol: any;
  pessoal_frances: any;
  pessoal_alemao: any;
  pessoal_italiano: any;
  pessoal_otidioma: any;
  pessoal_word: any;
  pessoal_excel: any;
  pessoal_cdraw: any;
  pessoal_pwpoint: any;
  pessoal_atcad: any;
  pessoal_internet: any;
  pessoal_otinform: any;
  pessoal_cursos: any;
  pessoal_pwd: string;
  pessoal_salario: number;
  pessoal_salario_n: any;
  pessoal_contratado: any;
  pessoal_indicado: any;
  pessoal_autemail: number;
  pessoal_aspessoais: any;
  pessoal_parecer: any;
  pessoal_asprof: any;
  pessoal_observ: any;
  pessoal_nota: any;
  pessoal_atrib: string;
  pessoal_digitacao: any;
  pessoal_senac: any;
  pessoal_senai: any;
  pessoal_priempre: number;
  pessoal_cefet: any;
  pessoal_empresa: any;
  pessoal_dtadmissao: any;
  pessoal_dtsaida: any;
  pessoal_motivo: any;
  pessoal_cargoemp: any;
  pessoal_atribemp: any;
  pessoal_empresa2: any;
  pessoal_dtadmissao2: any;
  pessoal_dtsaida2: any;
  pessoal_motivo2: any;
  pessoal_cargoemp2: any;
  pessoal_atribemp2: any;
  pessoal_empresa3: any;
  pessoal_dtadmissao3: any;
  pessoal_dtsaida3: any;
  pessoal_motivo3: any;
  pessoal_cargoemp3: any;
  pessoal_atribemp3: any;
  pessoal_bloqueado: number;
  pessoal_selecao: any;
  pessoal_codvelho: any;
  pessoal_ocupacao1: any;
  pessoal_ocupacao2: any;
  pessoal_ocupacao3: any;
  pessoal_ratividade: any;
  pessoal_ratividade2: any;
  pessoal_ratividade3: any;
  pessoal_treg: string;
  pessoal_treg2: string;
  pessoal_treg3: string;
  pessoal_cadinternet: any;
  pessoal_ultsalario: any;
  pessoal_ano: any;
  pessoal_entidade: any;
  pessoal_cargo: any;
  pessoal_pbicicleta: number;
  pessoal_pmoto: number;
  pessoal_dfisico: number;
  pessoal_dfisicoqual: any;
  pessoal_cid: any;
  pessoal_ng: any;
  pessoal_entrevista: any;
  pessoal_bloqate: any;
  pessoal_dtentrevista: any;
  pessoal_sine: string;
  pessoal_ncurso: number;
  pessoal_recrutadora: any;
  pessoal_ningles: number;
  pessoal_nespanhol: number;
  pessoal_nalemao: number;
  pessoal_nfrances: number;
  pessoal_nitaliano: number;
  pessoal_nfilhos: any;
  pessoal_ncursos: string;
  pessoal_maquina1: any;
  pessoal_maquina2: any;
  pessoal_maquina3: any;
  pessoal_vida: string;
  pessoal_numero: string;
  pessoal_recemp: any;
  pessoal_recemp2: any;
  pessoal_recemp3: any;
  pessoal_ultsalario2: any;
  pessoal_ultsalario3: any;
  pessoal_aspessoais2: any;
  pessoal_aspessoais_usa1: any;
  pessoal_aspessoais_usa2: any;
  pessoal_rentre: any;
  pessoal_aspessoais_n: any;
  pessoal_asprofissionais: any;
  pessoal_uniforme: any;
  cad_finalizado: string;
  cv_pessoal: any;
  fb_id: any;
  id: any;
  contas_id: number;
  soneca: number;
  soneca_data: null;
  pessoal_empregos?: any[];
};

const Curricullum = ({
  canId,
  data,
  observ,
  noProfile,
  selectedsCan,
  isLoadingCV,
  type = "system",
  setRef,
  printTrigger,
  onPrintReady,
}: CurriculumProps) => {
  const contentToPrint = useRef(null);
  const printTriggerHandled = React.useRef(0);

  const [dataCv, setDataCv] = React.useState<DatCvType>();

  const [canHistory, setCanHistory] = useState<any[]>([]);

  const { intrucaoSys } = useFunctions();
  const theme = useTheme();

  async function getCvInfo(canId: number) {
    const result = await getCandidateById(canId);

    setDataCv(result[0]);
  }

  const getHistory = async (id: number): Promise<any | boolean> => {
    const data = await getCanHistory(id);
    if (data as any) {
      setCanHistory(data as any[]);
      return data;
    }
    return false;
  };

  React.useEffect(() => {
    if (canId && printTrigger && printTrigger !== printTriggerHandled.current) {
      printTriggerHandled.current = printTrigger;
      getCvInfo(canId).then(() => {
        setTimeout(() => onPrintReady?.(), 150);
      });
    }
  }, [printTrigger]);

  React.useEffect(() => {
    setDataCv(undefined);
    setCanHistory([]);
    if (canId) {
      getCvInfo(canId);
      getHistory(canId);
    }
    setRef(contentToPrint);
  }, [canId]);

  const noProfileComp = () => {
    return (
      <div className="noProfileDiv">
        <div className="stickDivNoProfile slideInUp">Candidato SEM PERFIL</div>
      </div>
    );
  };
  const loadingCv = () => {
    return (
      <div className="loadingProfile">
        <div className="stickDivLoadingProfile slideInUp">
          <CircularProgress />
        </div>
      </div>
    );
  };

  const handlePrint = useReactToPrint({
    content: () => contentToPrint.current,
  });

  const selectedComp = () => {
    return (
      <div className="selectedCanDiv">
        <div className="stickDivSelectedCan slideInUp">
          Candidato SELECIONADO
        </div>
      </div>
    );
  };

  const columnsVagaHis: GridColDef[] = [
    {
      field: "nome_cliente",
      headerName: "Cliente",
      flex: 1,
      renderCell: (params: GridRenderCellParams<Number>) => {
        const value = params.value;
        const cargo = params.row.nome_cargo;
        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                fontWeight: "700",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {value}
            </div>
            {cargo && (
              <Chip
                label={cargo}
                size="small"
                color="primary"
                sx={{
                  height: 18,
                  fontSize: 10,
                  mt: 0.5,
                  maxWidth: "fit-content",
                }}
              />
            )}
          </Box>
        );
      },
    },
    {
      field: "dtselecao",
      headerName: "Selecionado",
      width: 120,
      renderCell: (params: GridRenderCellParams) => {
        const values = params.row;
        return (
          <>
            <Box display="flex" flexDirection="row" alignItems="center">
              <Tooltip
                disableInteractive
                title={`${values.selecionado_por} - ${values.selecionado_por_nome}`}
              >
                <Avatar
                  src={values.selecionado_por_img || undefined}
                  sx={{
                    width: 24,
                    height: 24,
                    fontSize: 12,
                    border: `1px solid ${theme.palette.info} !important`,
                  }}
                >
                  {values.selecionado_por_nome &&
                    values.selecionado_por_nome.slice(0, 2).toUpperCase()}
                </Avatar>
              </Tooltip>
              <Typography fontSize={12} fontWeight={500} sx={{ ml: 1 }}>
                {formatDate(values?.dtselecao.toString(), "dd/MM/yyyy")}
              </Typography>
            </Box>
          </>
        );
      },
    },
    {
      field: "contato",
      headerName: "Contato/Pré/Agenda",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        const values = params.row;
        return (
          <>
            <Box display="flex" flexDirection="row" alignItems="center">
              {values.chamado_por_nome && (
                <Tooltip
                  disableInteractive
                  title={`${values.chamadopor} - ${values.chamado_por_nome}`}
                >
                  <Avatar
                    src={values.chamado_por_img || undefined}
                    sx={{
                      width: 24,
                      height: 24,
                      fontSize: 12,
                      border: `1px solid ${theme.palette.info} !important`,
                    }}
                  >
                    {values.chamado_por_nome &&
                      values.chamado_por_nome.slice(0, 2).toUpperCase()}
                  </Avatar>
                </Tooltip>
              )}

              <Typography
                fontSize={12}
                fontWeight={500}
                sx={{
                  ml: 1,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {renderChamado(
                  values.contato_ok,
                  values.chamado,
                  values.chamado_texto,
                  values.contato_recado,
                  values.contato_recadotexto,
                  values.contato_natende,
                  values.contato_email,
                  values.contato_whats,
                  values.contato_sms,
                  values.contato_stelefone,
                  values.contato_trabalhando,
                  values.contato_semperfil,
                  values.contato_msemperfil,
                  values.contato_sinteresse,
                  values.contato_msinteresse,
                  values.contato_preentre,
                  values.veio_direto,
                )}
              </Typography>
            </Box>
          </>
        );
      },
    },
    {
      field: "dtentrevista",
      headerName: "Entrevistado",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        const values = params.row;
        return (
          <>
            <Box display="flex" flexDirection="row" alignItems="center">
              {values.entrevistado_por_nome && (
                <Tooltip
                  disableInteractive
                  title={`${values.entrevistadopor} - ${values.entrevistado_por_nome}`}
                >
                  <Avatar
                    src={values.entrevistado_por_img || undefined}
                    sx={{
                      width: 24,
                      height: 24,
                      fontSize: 12,
                      border: `1px solid ${theme.palette.info} !important`,
                    }}
                  >
                    {values.entrevistado_por_nome.slice(0, 2).toUpperCase()}
                  </Avatar>
                </Tooltip>
              )}

              <Typography
                fontSize={12}
                fontWeight={500}
                sx={{
                  ml: 1,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {renderEntrevista(
                  values.entrevista_pessoal,
                  values.entrevista_telefone,
                  values.entrevista_video,
                  values.aprovado,
                  values.enviado,
                  values.contato_standby,
                  values.entrevista_semperfil,
                  values.entrevista_msemperfil,
                  values.contratadodireto,
                  values.entrevista_sinteresse,
                  values.entrevista_msinteresse,
                  values.entrevista_disistiu,
                  values.entrevista_mdisistiu,
                )}
              </Typography>
            </Box>
          </>
        );
      },
    },
    {
      field: "retorno",
      headerName: "Retorno do Cliente",
      flex: 2,
      renderCell: (params: GridRenderCellParams) => {
        const values = params.row;
        return (
          <>
            <Box display="flex" flexDirection="row" alignItems="center">
              <Typography
                fontSize={12}
                fontWeight={500}
                sx={{
                  ml: 1,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                <RenderCliente
                  analise_ent_aprov={values.analise_ent_aprov}
                  analise_ean={values.analise_ean}
                  analise_motncomp={values.analise_motncomp}
                  aprovadocli={values.aprovadocli}
                  naprovadocli={values.naprovadocli}
                  mobscli={values.mobscli}
                  emanalisecli={values.emanalisecli}
                  analise_ent_naprov={values.analise_ent_naprov}
                  analise_motiivonaprov={values.analise_motiivonaprov}
                />
              </Typography>
            </Box>
          </>
        );
      },
    },
  ];

  return (
    <React.Fragment>
      {observ && dataCv?.pessoal_observ && (
        <ReactMarkdown className="observCv fadeIn">
          {dataCv?.pessoal_observ}
        </ReactMarkdown>
      )}

      <Grid container spacing={1}>
        <div
          style={{
            width: "964px",
            paddingLeft: "50px",
            paddingRight: "45px",
            position: "relative",
            paddingTop: "50px",
          }}
          ref={contentToPrint}
          className="corpo"
        >
          {isLoadingCV && loadingCv()}
          {noProfile?.includes(canId) && noProfileComp()}
          {selectedsCan?.includes(canId) && selectedComp()}

          {type == "system" && (
            <>
              {dataCv?.pessoal_dfisico == 1 && (
                <div className="pfisicoCv">
                  <Accessible fontSize="large" />
                </div>
              )}
              {dataCv?.pessoal_dtentrevista && (
                <div className="dtEntre">
                  <div className="dtEntreTitle">Entrevista</div>
                  {formatDate(dataCv?.pessoal_dtentrevista, "dd/MM/yyyy")}
                </div>
              )}
              {dataCv?.pessoal_dtinclusao && (
                <div className="dtInc">
                  <div className="dtIncTitle">Inclusão</div>
                  {formatDate(dataCv?.pessoal_dtinclusao, "dd/MM/yyyy")}
                </div>
              )}
              {dataCv?.pessoal_dtalteracao && (
                <div className="dtAtualizada">
                  <div className="dtAtualizadaTitle">Alteração</div>
                  {formatDate(dataCv?.pessoal_dtalteracao, "dd/MM/yyyy")}
                </div>
              )}
            </>
          )}

          <div style={{ width: "100%", display: "table" }}>
            <div
              style={{
                width: "100%",
                textAlign: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <img src={LogoCv} style={{ width: "200px", marginBottom: 15 }} />
            </div>

            <div
              style={{
                width: "100%",
                textAlign: "center",
                height: "27px",
                lineHeight: "9px",
                fontSize: "17px",
                opacity: 1,
              }}
            >
              www.agnesrh.com.br
            </div>
            <div
              style={{
                width: "100%",
                textAlign: "center",
                height: "30px",
                lineHeight: "0px",
                marginTop: "-3px",
                fontSize: "17px",
                opacity: 1,
              }}
            >
              Matriz Curitiba - (41)3322-0352
            </div>
          </div>

          <CanInfo
            dataCv={data || dataCv}
            id={data?.pessoal_codigo || dataCv?.pessoal_codigo || 0}
          />
          {data?.pessoal_cargos && data.pessoal_cargos.length > 0 && (
            <>
              <div
                style={{
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <h6
                  style={{
                    fontWeight: 100,
                    paddingBottom: "0px",
                    marginBottom: "9px",
                    marginTop: "10px",
                    paddingTop: "8px",
                    fontSize: "15px",
                    width: "100%",
                  }}
                >
                  Funções Pretendidas
                </h6>
              </div>
              <div
                className="jobs_cur"
                style={{
                  textAlign: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexWrap: "wrap",
                  paddingBottom: "8px",
                  gap: "5px",
                }}
              >
                {data?.pessoal_cargos?.map((item: any, index: number) => (
                  <TagsJobs key={index} data={item.nome} />
                ))}
              </div>
            </>
          )}

          {dataCv?.pessoal_ncursos && (
            <>
              <div
                style={{
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <h6
                  style={{
                    fontWeight: 100,
                    paddingBottom: "0px",
                    marginBottom: "9px",
                    marginTop: "10px",
                    paddingTop: "8px",
                    fontSize: "15px",
                    width: "100%",
                  }}
                >
                  Cursos Realizados
                </h6>
              </div>
              <div style={{ width: "100%", display: "table" }}>
                <div style={{ width: "100%", float: "left" }}>
                  <b>{dataCv?.pessoal_ncursos}</b>
                  <br />
                </div>
              </div>
            </>
          )}

          {data?.pessoal_formacoes && data.pessoal_formacoes.length > 0 && (
            <>
              <div
                style={{
                  textAlign: "center",
                  justifyContent: "center",
                }}
              >
                <h6
                  style={{
                    fontWeight: 100,
                    paddingBottom: "0px",
                    marginBottom: "9px",
                    marginTop: "10px",
                    paddingTop: "8px",
                    fontSize: "15px",
                    width: "100%",
                  }}
                >
                  Formação do Candidato
                </h6>
              </div>
            </>
          )}

          <div style={{ width: "100%" }}>
            {data?.pessoal_formacoes?.map((item: any, index: number) => (
              <div
                key={index}
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div style={{ height: "100%", width: "20px" }}>
                  <School style={{ fontSize: "13px" }} />
                </div>
                <div style={{ height: "100%", width: "calc(100% - 20px)" }}>
                  <div
                    style={{
                      width: "100%",
                      paddingBottom: "15px",
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    <div style={{ width: "50%" }}>
                      Nível de Formação:{" "}
                      <b>
                        {item?.formacao_n_OBJECT?.nf_descricao ||
                          "Não informado"}
                      </b>
                      <br />
                    </div>
                    <div style={{ width: "50%" }}>
                      Curso:{" "}
                      <b>
                        {item?.formacao_cursos_OBJECT?.formacoes_descricao ||
                          "Não informado"}
                      </b>
                      <br />
                    </div>
                    <div style={{ width: "50%" }}>
                      Instituição de Ensino:{" "}
                      <b>{item?.instituicao || "Não informado"}</b>
                      <br />
                    </div>
                    <div style={{ width: "50%" }}>
                      Cidade: <b>{item?.cidade || "Não informado"}</b>
                      <br />
                    </div>
                    <div style={{ width: "50%" }}>
                      Ano de Conclusão: <b>{item?.ano || "Cursando"}</b>
                      <br />
                    </div>
                    {item?.turno && (
                      <div style={{ width: "50%" }}>
                        Turno: <b>{item?.turno}</b>
                        <br />
                      </div>
                    )}
                    {item?.entidade && (
                      <div style={{ width: "100%" }}>
                        Entidade / Faculdade: <b>{item?.entidade}</b>
                        <br />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div
            style={{ width: "100%", display: "none" }}
            className="exp_pro_sigecor"
          >
            <input type="hidden" defaultValue={1} id="valor_exp" />
            <div style={{ width: "100%" }} className="titulo">
              EXPERIÊNCIA PROFISSIONAL (SIGECOR)
            </div>
            <br />
            <div
              style={{
                width: "100%",
                height: "40px",
                position: "relative",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  float: "left",
                  fontSize: "21px",
                  borderBottom: "1px solid",
                  paddingBottom: "4px",
                }}
              >
                Último Emprego
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div style={{ width: "33.33%", float: "left" }}>
                Empresa: <b />
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Ramo de Atividade: <b />
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Cargo: <b />
                <br />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div style={{ width: "33.33%", float: "left" }}>
                Admissão: <b>31/12/1969</b>
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Saída: <b>31/12/1969</b>
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Motivo: <b />
                <br />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div style={{ width: "33.33%", float: "left" }}>
                Tipo Contrato: <b />
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Trabalhava c/: <b />
                <br />
              </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <div style={{ width: "100%" }}>Atividades/Funções Exercidas:</div>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  width: "85%",
                  float: "left",
                  textAlign: "justify",
                  lineHeight: "20px",
                }}
              >
                <b />
                <br />
                <br />
                <b />
                <br />
              </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div
              style={{
                width: "100%",
                height: "40px",
                position: "relative",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  float: "left",
                  fontSize: "21px",
                  borderBottom: "1px solid",
                  paddingBottom: "4px",
                }}
              >
                Penúltimo Emprego
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div style={{ width: "33.33%", float: "left" }}>
                Empresa: <b />
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Ramo de Atividade: <b />
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Cargo: <b />
                <br />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div style={{ width: "33.33%", float: "left" }}>
                Admissão: <b>31/12/1969</b>
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Saída: <b>31/12/1969</b>
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Motivo: <b />
                <br />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div style={{ width: "33.33%", float: "left" }}>
                Tipo Contrato: <b />
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Trabalhava c/: <b />
                <br />
              </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <div style={{ width: "100%" }}>Atividades/Funções Exercidas:</div>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  float: "left",
                  textAlign: "justify",
                  lineHeight: "20px",
                }}
              >
                <b />
                <br />
                <br />
                <b />
                <br />
              </div>
              <br />
              <br />
            </div>
            <div
              style={{
                width: "100%",
                height: "40px",
                position: "relative",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  float: "left",
                  fontSize: "21px",
                  borderBottom: "1px solid",
                  paddingBottom: "4px",
                }}
              >
                Antepenúltimo Emprego
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div style={{ width: "33.33%", float: "left" }}>
                Empresa: <b />
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Ramo de Atividade: <b />
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Cargo: <b />
                <br />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div style={{ width: "33.33%", float: "left" }}>
                Admissão: <b>31/12/1969</b>
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Saída: <b>31/12/1969</b>
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Motivo: <b />
                <br />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div style={{ width: "33.33%", float: "left" }}>
                Tipo Contrato: <b />
                <br />
              </div>
              <div style={{ width: "33.33%", float: "left" }}>
                Trabalhava c/: <b />
                <br />
              </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <div style={{ width: "100%" }}>Atividades/Funções Exercidas:</div>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  float: "left",
                  textAlign: "justify",
                  lineHeight: "20px",
                }}
              >
                <b />
                <br />
                <br />
                <b />
                <br />
              </div>
              <br />
              <br />
            </div>
          </div>
          <div style={{ width: "100%", display: "table" }} className="titulo">
            <div
              style={{
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <h6
                style={{
                  fontWeight: 100,
                  paddingBottom: "0px",
                  marginBottom: "9px",
                  paddingTop: "8px",
                  fontSize: "15px",
                  width: "100%",
                  marginTop: "10px",
                }}
              >
                Experiência Profissional
              </h6>
            </div>
          </div>
          {(data?.pessoal_priempre == 1 ||
            data?.pessoal_priempre === true ||
            dataCv?.pessoal_priempre == 1 ||
            Boolean(dataCv?.pessoal_priempre) === true) && (
            <div
              style={{
                width: "100%",
                justifyContent: "center",
                display: "flex",
                marginBottom: "10px",
                padding: "10px",
                backgroundColor: "#fff3cd",
                borderRadius: "5px",
              }}
            >
              <b>Candidato buscando primeiro emprego!</b>
            </div>
          )}
          {(data?.pessoal_empregos && data.pessoal_empregos.length > 0) ||
          (dataCv?.pessoal_empregos && dataCv.pessoal_empregos.length > 0) ? (
            <div style={{ width: "100%" }}>
              {(data?.pessoal_empregos || dataCv?.pessoal_empregos)?.map(
                (item: any, index: number) => (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div style={{ height: "100%", width: "20px" }}>
                      <Circle style={{ fontSize: "11px" }} />
                    </div>
                    <div style={{ height: "100%", width: "calc(100% - 20px)" }}>
                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            width: "100%",
                            float: "left",
                            fontSize: "20px",
                            paddingBottom: 10,
                          }}
                        >
                          Empresa: <b>{item?.empresa}</b>
                          <br />
                        </div>
                      </div>
                      <div style={{ width: "100%" }}>
                        <div style={{ width: "100%", float: "left" }}>
                          Na cidade de <b>{item?.cidade}</b>
                          <br />
                        </div>
                      </div>
                      <div style={{ width: "100%" }}>
                        <div style={{ width: "66.66%", float: "left" }}>
                          Ramo de Atividade: <b>{item?.empresa_ratividade}</b>
                          <br />
                        </div>
                        <div style={{ width: "33.33%", float: "left" }}>
                          Cargo: <b>{item?.cargo?.nome}</b>
                          <br />
                        </div>
                      </div>
                      <div style={{ width: "100%" }}>
                        <div style={{ width: "33.33%", float: "left" }}>
                          Admissão:{" "}
                          <b>{formatDate(item?.dt_admissao, "dd/MM/yyyy")}</b>
                          <br />
                        </div>
                        <div style={{ width: "33.33%", float: "left" }}>
                          {item?.empatual == 1 ? (
                            <b>Até o momento</b>
                          ) : (
                            <>
                              Saída:{" "}
                              <b>{formatDate(item?.dt_saida, "dd/MM/yyyy")}</b>
                            </>
                          )}

                          <br />
                        </div>
                        <div style={{ width: "33.33%", float: "left" }}>
                          Experiência:{" "}
                          <b>
                            {" "}
                            {calcExp(
                              item?.dt_admissao,
                              item?.dt_saida,
                              item?.empatual,
                            )}
                          </b>
                          <br />
                        </div>
                      </div>
                      <div style={{ width: "100%", display: "table" }}>
                        {item?.tipo && (
                          <div style={{ width: "33.33%", float: "left" }}>
                            Tipo Contrato: <b>{getContractType(item?.tipo)}</b>
                            <br />
                          </div>
                        )}
                        {item?.turno && (
                          <div style={{ width: "33.33%", float: "left" }}>
                            Turno: <b>{getTimeType(item?.turno)}</b>
                            <br />
                          </div>
                        )}

                        <div style={{ width: "33.33%", float: "left" }}>
                          Último Salário: <b> {renderSalary(item?.salario)}</b>
                          <br />
                        </div>
                        {item?.empatual == 0 && (
                          <div style={{ width: "100%", float: "left" }}>
                            Motivo Saída: <b>{item?.motivo}</b>
                            <br />
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          paddingBottom: "20px",
                          width: "100%",
                          display: "table",
                          marginLeft: 0,
                        }}
                      >
                        {item?.ativ_desenpenhadas && (
                          <div
                            style={{
                              width: "100%",
                              display: "table",
                              marginLeft: 0,
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                display: "table",
                                paddingTop: "8px",
                              }}
                            >
                              <b>Atividades/Funções Exercidas:</b>
                            </div>
                            <div
                              style={{
                                width: "100%",
                                float: "left",
                                textAlign: "justify",
                                paddingBottom: "15px",
                                lineHeight: "20px",
                              }}
                            >
                              {item?.ativ_desenpenhadas}
                              <br />
                            </div>
                          </div>
                        )}
                        {item?.maquina_op == 1 && (
                          <div
                            style={{
                              width: "100%",
                              float: "left",
                              textAlign: "justify",
                              paddingBottom: "15px",
                              lineHeight: "20px",
                            }}
                          >
                            <div style={{ width: "100%", float: "left" }}>
                              Trabalhava com as seguintes maquinas:{" "}
                              <b>{item?.maquina}</b>
                            </div>
                            <br />
                          </div>
                        )}
                        {item?.sistema_op == 1 && (
                          <div
                            style={{
                              width: "100%",
                              float: "left",
                              textAlign: "justify",
                              paddingBottom: "15px",
                              lineHeight: "20px",
                            }}
                          >
                            <div style={{ width: "100%", float: "left" }}>
                              Trabalhava com os seguintes sistemas:{" "}
                              <b>{item?.sistema}</b>
                            </div>{" "}
                            <br />
                          </div>
                        )}

                        {item?.desc_recruta && (
                          <div
                            style={{
                              width: "100%",
                              float: "left",
                              textAlign: "justify",
                              paddingBottom: "15px",
                              lineHeight: "20px",
                            }}
                          >
                            <div style={{ width: "100%", float: "left" }}>
                              <b>Em entrevista na Agnes relatou: </b>
                              <br />
                              {item?.desc_recruta}
                            </div>
                            <br />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ),
              )}
            </div>
          ) : null}

          {type == "system" && (
            <div
              className="row"
              id="historico_web"
              style={{ display: "table", width: "100%" }}
            >
              <div className="col-md-12">
                <div
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <h6
                    style={{
                      fontWeight: 100,
                      paddingBottom: "0px",
                      marginBottom: "9px",
                      marginTop: "0px",
                      paddingTop: "8px",
                      borderBottom: "1px solid #eee",
                      fontSize: "15px",
                      width: "100%",
                    }}
                  >
                    Histórico
                  </h6>
                </div>
                <div id="historico_ajax_can">
                  <Grid
                    container
                    style={{
                      minHeight: "300px",
                    }}
                  >
                    <DataGrid
                      rows={canHistory}
                      getRowId={(row) =>
                        row.id ??
                        `${row.vaga}-${row.candidato}-${row.dtselecao}`
                      }
                      getRowHeight={() => "auto"}
                      autoHeight
                      columns={columnsVagaHis}
                      pageSize={20}
                      rowsPerPageOptions={[20]}
                      localeText={
                        ptBR.components.MuiDataGrid.defaultProps.localeText
                      }
                      sx={{
                        width: "100%",
                        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell":
                          {
                            py: 1,
                          },
                        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell":
                          {
                            py: 1,
                          },
                        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell":
                          {
                            py: 2,
                          },
                      }}
                      components={{
                        NoRowsOverlay: () => (
                          <Stack
                            height="100%"
                            alignItems="center"
                            display="flex"
                            direction="row"
                            justifyContent="center"
                          >
                            <SvgContainer>
                              <HelpSvg height="200px" width="200px" />
                            </SvgContainer>
                            <Typography variant="h6">
                              Nenhum Histórico
                            </Typography>
                          </Stack>
                        ),
                      }}
                    />
                  </Grid>
                </div>
              </div>
            </div>
          )}

          {dataCv?.pessoal_vida && (
            <>
              <div
                style={{ width: "100%", textAlign: "center" }}
                className="titulo"
              >
                <div
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <h6
                    style={{
                      fontWeight: 100,
                      paddingBottom: "0px",
                      marginBottom: "9px",
                      marginTop: "10px",
                      paddingTop: "8px",
                      fontSize: "15px",
                      width: "100%",
                    }}
                  >
                    Fale de Você (Candidato)
                  </h6>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  whiteSpace: "pre-line",
                  paddingBottom: 20,
                }}
              >
                {dataCv?.pessoal_vida}
              </div>
            </>
          )}

          {dataCv?.pessoal_atrib && (
            <>
              <div
                style={{ width: "100%", textAlign: "center" }}
                className="titulo"
              >
                <div
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  <h6
                    style={{
                      fontWeight: 100,
                      paddingBottom: "0px",
                      marginBottom: "9px",
                      marginTop: "10px",
                      paddingTop: "8px",
                      fontSize: "15px",
                      width: "100%",
                    }}
                  >
                    Outras Atribuições
                  </h6>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  whiteSpace: "pre-line",
                  paddingBottom: 20,
                }}
              >
                {dataCv?.pessoal_atrib}
              </div>
            </>
          )}

          <div
            style={{ width: "100%", textAlign: "center" }}
            className="titulo"
          >
            <div
              style={{
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <h6
                style={{
                  fontWeight: 100,
                  paddingBottom: "0px",
                  marginBottom: "9px",
                  marginTop: "10px",
                  paddingTop: "8px",
                  fontSize: "15px",
                  width: "100%",
                }}
              >
                Avaliação da Recrutadora
              </h6>
            </div>
          </div>

          {dataCv?.pessoal_recrutadora ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                whiteSpace: "pre-line",
                paddingBottom: 20,
              }}
            >
              {dataCv?.pessoal_recrutadora}
            </div>
          ) : (
            <div style={{ width: "100%", paddingBottom: 20 }}>
              Nenhuma avaliação.
            </div>
          )}

          <div
            style={{ width: "100%", textAlign: "center" }}
            className="titulo"
          >
            <div
              style={{
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <h6
                style={{
                  fontWeight: 100,
                  paddingBottom: "0px",
                  marginBottom: "9px",
                  marginTop: "0px",
                  paddingTop: "8px",
                  fontSize: "15px",
                  width: "100%",
                }}
              >
                Avaliação de Aspectos Técnicos e Profissionais
              </h6>
            </div>
          </div>
          {dataCv?.pessoal_rentre ? (
            <div
              style={{
                width: "100%",
                whiteSpace: "pre-line",
                display: "flex",
                paddingBottom: 20,
              }}
            >
              {dataCv?.pessoal_rentre}
            </div>
          ) : (
            <div style={{ width: "100%", paddingBottom: 20 }}>
              Nenhuma avaliação.
            </div>
          )}

          <div
            style={{ width: "100%", textAlign: "center" }}
            className="titulo"
          >
            <div
              style={{
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <h6
                style={{
                  fontWeight: 100,
                  paddingBottom: "0px",
                  marginBottom: "9px",
                  marginTop: "0px",
                  paddingTop: "8px",
                  fontSize: "15px",
                  width: "100%",
                }}
              >
                Parecer da Entrevista
              </h6>
            </div>
          </div>
          {dataCv?.pessoal_aspessoais ? (
            <div
              style={{
                width: "100%",
                whiteSpace: "pre-line",
                display: "flex",
                paddingBottom: 20,
              }}
            >
              {dataCv?.pessoal_aspessoais}
            </div>
          ) : (
            <div style={{ width: "100%", paddingBottom: 20 }}>
              Nenhum parecer.
            </div>
          )}

          <div
            style={{ width: "100%", textAlign: "center" }}
            className="titulo"
          >
            <div
              style={{
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <h6
                style={{
                  fontWeight: 100,
                  paddingBottom: "0px",
                  marginBottom: "9px",
                  marginTop: "0px",
                  paddingTop: "8px",
                  fontSize: "15px",
                  width: "100%",
                }}
              >
                Uniforme
              </h6>
            </div>
          </div>
          {dataCv?.pessoal_uniforme ? (
            <div
              style={{
                width: "100%",
                whiteSpace: "pre-line",
                display: "flex",
                paddingBottom: 20,
              }}
            >
              {dataCv?.pessoal_uniforme}
            </div>
          ) : (
            <div style={{ width: "100%", paddingBottom: 20 }}>
              Nenhuma informação.
            </div>
          )}

          <div
            style={{
              width: "100%",
              display: "table",
              /*whiteSpace: 'pre-wrap', */ textAlign: "justify",
              paddingBottom: "15px",
              lineHeight: "20px",
            }}
          ></div>
        </div>
      </Grid>
    </React.Fragment>
  );
};

export default Curricullum;
